import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store/index';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  // mode: 'hash',
  mode: 'history',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});
router.beforeEach((to, from, next) => {
  try{
  let path = to.fullPath.replace(to.fullPath.slice(0,1),'');
  let login = localStorage.getItem('login');
  if(path != 'login' && login == null && path != "sign-up" && !path.includes('#')){
    store.commit('setPrevPath',path);
    localStorage.removeItem('login');
    localStorage.removeItem('type');
    next('/login');
  }else{
    if(path == 'login' || path == "sign-up"){
      let prevPath = store.getters.prevPath;
      if(prevPath && prevPath != '/'){
        localStorage.setItem('LS_ROUTE_KEY',prevPath);
      }
      localStorage.removeItem('login');
      localStorage.removeItem('type');
      next();
    }else{
     next();
    }
  }
  }catch (e) {
    if(to.fullPath != '/login'){
      next('/login');
    }
    localStorage.clear();
    console.log("Error", e);
  }
});


export default router;
